module.exports = __webpack_public_path__ + "static/status_pay_succ.e917a5a4.png";